module.exports = __webpack_public_path__ + "static/media/webapp_background_stage@3x.52fb16c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/webapp_background_stage/webapp_background_stage@3x.png
// module id = 223
// module chunks = 0